import React, { useState, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { VehicleDetectionImage } from './VehicleDetectionImage';

export const QCVehicleDetection = (props) => {
	const [drawnLayers, setDrawnLayers] = useState([]);
	const drawnLayersRef = useRef([]);

    const deleteLayer = (layerId) => {
        console.log(layerId)
        drawnLayersRef.current = drawnLayersRef.current.filter(layer => layer.id != layerId)
    }

	console.log(drawnLayersRef);
    

	return (
		<>
			{props.authProps.isAuthenticated ? (
				<>
					<div className="px-0 col" id="secondColumn">
						<div className="contentContainer">
							<div style={{ marginTop: '58px' }}>
								<hr className="container-hr"></hr>

								<h3>Vehicle Detection QC</h3>

								<div className="row" style={{ height: '85vh' }}>
									<div className="col-5">
										<h5 className="text-center">MAP</h5>

										<VehicleDetectionImage
											drawnLayers={drawnLayers}
											setDrawnLayers={setDrawnLayers}
											drawnLayersRef={drawnLayersRef}
										/>
									</div>
									<div className="col-7">
										<h5 className="text-center">GEOM</h5>
										<table className="mt-5" style={{width: '100%'}}>
											<thead>
												<tr>
													<th>ID</th>
													<th>Type</th>
													<th>No. points</th>
													<th>Name</th>

													<th>Description</th>
													<th>Tags</th>
													<th>Delete layer</th>
												</tr>
											</thead>

											<tbody>
												{drawnLayersRef.current.map((layer, i) => {
													return (
														<tr>
															<td>{layer.id}</td>
															<td>{layer.geometry.type}</td>
															<td>{layer.geometry.coordinates[0].length}</td>
															<td>
																<input className="form-control" type="text"></input>
															</td>
															<td>
																<input className="form-control" type="text"></input>
															</td>
															<td>
																<input className="form-control"  type="text"></input>
															</td>
															<td>
																<button className="btn noStyleButton" onClick={(e)=>deleteLayer(layer.id)}>
                                                                <i className="fa-solid fa-trash-can"></i>
																</button>
															</td>
														</tr>
													);
												})}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			) : (
				<Navigate to="/login" />
			)}
		</>
	);
};
